module.exports = __webpack_public_path__ + "img/logoRights.fc50f23d.png";